module.exports = __webpack_public_path__ + "static/media/Benifits7.f211fb2f.webp";